<template>
  <div>
    <div class="bg-grey_3 pa-2 bordered mb-4 rounded">
      <div class="d-flex justify-space-between align-items-center mb-2 flex-wrap">
        <div class="text-h6 text-darkblue">
          <b>Parcours Prévention Santé (PPS)</b> - <span v-if="status.includes('revenir')">(PPS à réaliser à partir du
            {{ date_validite_pps }})</span><span v-else>(Validité de 3 mois)</span>
        </div>
        <a v-if="!status.includes('revenir')" href="https://pps.athle.fr/" target="_blank"><v-btn color="primary-dark"
            variant="elevated" elevation="0">Faire mon PPS</v-btn></a>
      </div>

      <div v-if="status == 'pps_and_certif'">Afin de valider votre inscription, vous pourrez fournir <b>un certificat
          médical, ou votre numéro de PPS</b>.</div>
      <div v-if="status == 'pps'">Afin de valider votre inscription, vous pourrez fournir <b>votre numéro de PPS</b>.</div>
      <div v-if="status == 'pps_revenir'">
        <b>Votre PPS est valable 3 mois</b> Vous devrez réaliser votre PPS à partir du : <b>{{ date_validite_pps
          }}</b><br />
        Si vous avez déjà un numéro d'attestation PPS, il vous faudra à nouveau suivre le parcours de prévention
        santé.<br />
        Inscrivez-vous dès maintenant, nous vous enverrons un rappel dès le {{ date_validite_pps }} pour effectuer votre
        PPS et indiquer le numéro d'attestation délivré dans votre fiche d'inscription. Votre inscription sera validée.
        (<b>La vérification est automatique, pensez à vérifier la saisie de vos nom et prénom à l'identique</b>)
      </div>
      <div v-if="status == 'pps_and_certif_revenir'">
        Afin de valider votre inscription, vous pourrez fournir <b>un certificat médical, ou votre numéro de
          PPS</b>.<br />
        <b>Votre PPS est valable 3 mois</b> Vous devrez réaliser votre PPS à partir du : <b>{{ date_validite_pps
          }}</b><br />
        Si vous avez déjà un numéro d'attestation PPS, il vous faudra à nouveau suivre le parcours de prévention
        santé.<br />
        Inscrivez-vous dès maintenant, nous vous enverrons un rappel dès le {{ date_validite_pps }} pour effectuer votre
        PPS et indiquer le numéro d'attestation délivré dans votre fiche d'inscription. Votre inscription sera validée.
        (<b>La vérification est automatique, pensez à vérifier la saisie de vos nom et prénom à l'identique</b>)
      </div>
      <div v-if="mainStore.module && mainStore.module.base == 'VVX25'">
        <b>Toutefois, l'organisation rappelle que le trail constitue un effort important et conséquent. Il est donc
          vivement conseillé aux personnes présentant des pathologies cardiaques ou respiratoires de
          consulter un médecin avant de participer à l'événement.</b>
      </div>
      <div class="d-flex justify-center">
        <img class="px-2 pa-2" style="max-width: 100%;" v-if="with_image"
          v-bind:src="require('@/assets/img/pps.png')" />
      </div>

      <hr />
      <div class="text-h6 text-darkblue">Foire aux questions</div>
      <v-expansion-panels>
        <v-expansion-panel elevation="0">
          <v-expansion-panel-title>
            <p class="my-2">Le PPS, c'est quoi?</p>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <p>Le Parcours Prévention Santé (PPS), mis en place par la Fédération Française d’Athlétisme dans le cadre
              de la loi « Sport » du 2 mars 2022, révolutionne le processus d'inscription aux courses running en France.
            </p>
            <p>
              Pour les participants majeurs, il remplace le traditionnel certificat médical d'aptitude à la pratique
              sportive et simplifie ainsi les démarches d'inscription. Désormais, tout participant majeur souhaitant
              s’inscrire à une course
              running devra suivre le PPS en ligne sur la plateforme dédiée pps.athle.fr, dans les trois mois précédant
              la compétition. Ce parcours vise à sensibiliser les coureurs aux risques, précautions et recommandations
              liés à la pratique de la
              course à pied, à travers du contenu pédagogique comprenant texte et vidéo.
            </p>
            <p>
              Les licenciés FFA majeurs, ayant déjà suivi le PPS pour leur prise de licence, sont exemptés de cette
              démarche avant chaque course. Les non licenciés mineurs doivent répondre à un questionnaire spécifique et
              fournir un certificat
              médical si nécessaire pour s'inscrire. Le parcours en ligne sensibilise les participants à diverses
              problématiques telles que les signaux d'alerte, les précautions selon l'âge, l'importance de consulter un
              médecin en cas de risques
              identifiés, et l'incitation à se former aux gestes qui sauvent. À la fin du PPS, le participant peut
              obtenir une attestation à remettre à l'organisateur avant la course.
            </p>
            <p>
              Le déploiement du PPS sur l'ensemble des courses running se fait progressivement d'avril à août 2024, pour
              une application obligatoire à partir du 1er septembre 2024. Un échéancier a été établi en fonction des
              dates d'ouverture des
              inscriptions et des dates des compétitions pour chaque événement.
            </p>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel elevation="0">
          <v-expansion-panel-title>
            <p class="my-2">Puis-je fournir un certificat médical ou mon PPS ?</p>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div v-if="is_after_septembre">Le certificat médical n'est plus accepté pour les courses. Vous devrez fournir le numéro de votre dernier PPS (moins de 3 mois) pour valider votre
              inscription.</div>
            <div v-else>
              L'un ou l'autre permettra de valider votre inscription pour un événement ayant lieu avant le 1er
              Septembre. Ajouter votre certificat médical ou le numéro de votre dernier PPS (moins de 3 mois) pour
              valider votre inscription.
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel elevation="0">
          <v-expansion-panel-title>
            <p class="my-2">Ai-je besoin du PPS?</p>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <ul>
              <li>Licenciés FFA et mineurs, pas besoin du PPS</li>
              <li>Pas de changement pour les licenciés FFA, on valide votre inscription automatiquement avec votre
                numéro de licence.</li>
              <li>Pas de changement pour les mineurs, votre questionnaire de santé est à compléter dans votre procédure
                d'inscription.</li>
            </ul>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel elevation="0">
          <v-expansion-panel-title>
            <p class="my-2">Comment obtenir mon numéro de PPS?</p>
          </v-expansion-panel-title>
          <v-expansion-panel-text> Il vous suffit de suivre la procédure sur le site <a href="https://pps.athle.fr/"
              target="_blank">pps.athle.fr</a>. </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      <div></div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: {
    with_image: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
    date_validite_pps() {
      return this.$moment(this.mainStore.module.evenement.date_fin).subtract(3, "months").format("DD/MM/YYYY");
    },
    is_after_septembre() {
      return this.$moment(this.mainStore.module.evenement.date_fin).isAfter("2024-08-31");
    },
    status() {
      let status = "pps_and_certif";
      let date_fin = this.mainStore.module.evenement.date_fin;
      if (this.$moment(date_fin).isAfter("2024-08-31")) {
        status = "pps";
      }

      if (this.$moment(date_fin).diff(this.$moment(), "months") >= 3) {
        status += "_revenir";
      }
      return status;
    },
  },
};
</script>

<style lang="scss"></style>